import { React, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import "../acco-input/accoInput.css";

function AccommodationInput({ postRoute, onSuccess }) {
  const { register, handleSubmit } = useForm();
  const [errorMessage, setErrorMessage] = useState(null);
  const { trip_id } = useParams(); // Get trip_id from URL parameters

  const onFormSubmit = async (data) => {
    try {
      // Create accommodation data to be sent
      const accommodationData = {
        ...data,
        trip_id: trip_id, // Add the trip_id to the data
      };

      // Post the accommodation data to the backend
      const response = await axios.post(postRoute, accommodationData);
      console.log("Response from server:", response);

      // Notify the parent (Planner.js) about the success
      if (onSuccess) onSuccess("Accommodation added successfully");
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      setErrorMessage(
        err.response?.data?.error || "An unexpected error occurred."
      );
    }
  };

  const onErrors = (errors) => console.error(errors);

  return (
    <div className="accommodation-input-container">
      <div className="planner-title">
        <p className="planner-heading">New Accommodation</p>
      </div>

      <form
        className="accommodation-detail"
        onSubmit={handleSubmit(onFormSubmit, onErrors)}
      >
        <div className="planner-label-container">
          <label className="planner-label">Accommodation Name:</label>
          <input
            type="text"
            {...register("name")}
            placeholder="Accommodation Name"
            className="planner-text"
          />
        </div>

        <div className="planner-label-container">
          <label className="planner-label">Address:</label>
          <textarea
            {...register("address")}
            placeholder="Address of the accommodation"
            className="planner-text"
          />
        </div>

        <div className="planner-label-container">
          <label className="planner-label">Check-in Date:</label>
          <input
            type="date"
            {...register("check_in_date")}
            className="planner-text"
          />
        </div>

        <div className="planner-label-container">
          <label className="planner-label">Check-out Date:</label>
          <input
            type="date"
            {...register("check_out_date")}
            className="planner-text"
          />
        </div>

        {errorMessage && <p className="error">{errorMessage}</p>}

        <button type="submit" className="add-button">
          Save Accommodation
        </button>
      </form>
    </div>
  );
}

export default AccommodationInput;
